import { loadBackgroundImages } from "@/helpers/image_loader"

loadBackgroundImages()
